import { Icon } from "./icon"

const gettext = window.gettext

export const Summary = (props) => {
  return (
    <>
      {props.sections.map((section) => {
        return (
          <div key={section.id} class="summary-container">
            <h2>{section.title}</h2>
            {section.step
              ? <button
                  class="button edit-button"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault()
                    props.form.showStep(0, section.step)
                  }}
                >
                  <span>{gettext("edit")}</span>
                  <Icon name="pencil" />
                </button>
              : null}
            <div class="summary-list">
              {section.includes.map((include) => {
                const labels = props.form.storedValues
                  .filter((o) => include.id === o.name)
                  .map((s) => s.label)
                return labels.length > 0
                  ? <>
                      <div class="summary-list-title">{include.title}:</div>
                      {labels.map((s) => (
                        <div class="summary-list-item">{s}</div>
                      ))}
                    </>
                  : ""
              })}
            </div>
          </div>
        )
      })}
    </>
  )
}
